import React, { Component } from 'react';
import LoadingBlock from "../Loading/LoadingBlock"
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import { checkAuth } from '../../authentication/actions/Login';
import OrderScanCommand from '../../orders/components/OrderScanCommand';
import { isMobileApp } from '../../../v2/hooks/useMobileApp';

import './App.css';

class AppContainer extends Component {
    componentDidMount() {
        this.props.dispatch(checkAuth());
    }

    componentDidUpdate() {
        this.enforceMobileAccess();
    }

    // On the installed mobile PWA, non-admins live entirely in v2 (Tickete +
    // Rapoarte zilnice). If one lands on any classic (v1) route, bounce them to
    // v2. Admins (level 3) keep full access everywhere.
    enforceMobileAccess() {
        const { authentication, router, dispatch } = this.props;
        const user = authentication && authentication.user;
        if (!user || !user.role) return; // wait until the profile is loaded
        if ((user.role.level || 0) >= 3) return; // admins: unrestricted
        if (!isMobileApp()) return; // only the mobile PWA / ?mobile override
        const path = router && router.location && router.location.pathname;
        if (!path) return;
        if (path === '/' || path.indexOf('/v2') === 0 || path.indexOf('/login') === 0) return;
        dispatch(push('/v2'));
    }

    render() {
        return <div id="kritware-orchestrator-app">
                <LoadingBlock/>
                <OrderScanCommand/>
                {this.props.children}
        </div>
    }
}

function mapStateToProps(state) {
    return state;
}

export default connect(mapStateToProps)(AppContainer);